Ext.ns('mx.comp');

mx.comp.DrawCircle = Ext.extend(Ext.form.TriggerField, {
    triggerClass: 'mx-comp-draw-circle-trigger',
    readOnly: true,
    labels: {
        noCircleDrawn: "Please, draw a circle on map (or hit 'Cancel' to close without filtering)",
        error: 'Error',
        circleWithRadius: 'Circle with radius = {0} km',
        mapWindowTitle: 'Draw a circle on map',
        removeCircle: 'Remove circle',
    },
    aocStore: null, // these stores should come as construcytor options
    divisionStore: null,

    circle: null,
    rawValue: null,

    initComponent: function() {
        mx.comp.DrawCircle.superclass.initComponent.call(this);
        var thiz = this;

        this.on('render', function() {
            this.trigger.dom.title = thiz.labels.mapWindowTitle;
        });
    },
    setDivisionStore: function(store) {
        this.divisionStore = store;
    },
    getCircle: function() {
        return this.circle;
    },

    onTriggerClick: function() {
        if (this.disabled) {
            return;
        }
        if (!this.circle) {
            this.mapWindow = new mx.app.widget.WindowForm({
                formClass: mx.app.widget.MapCircle,
                title: this.labels.mapWindowTitle,
                editable: true,
                resizable: true,
                maximizable: true,
                width: 650,
                minHeight: 300,
                listeners: {
                    ok: {
                        fn: function() {
                            if (this.mapWindow.form.circle) {
                                var text = this.labels.circleWithRadius.replace(
                                    '{0}',
                                    Math.round(this.mapWindow.form.circle.meters / 1000)
                                );
                                this.circle = this.mapWindow.form.circle;
                                this.setValue(text);
                                this.trigger.dom.className =
                                    'x-form-trigger mx-comp-draw-circle-trigger mx-comp-draw-circle-cancel';
                                this.trigger.dom.title = this.labels.removeCircle;
                            } else {
                                Ext.Msg.alert(this.labels.error, this.labels.noCircleDrawn);
                                return false;
                            }
                        },
                        scope: this,
                    },
                },
                formClassConfig: {
                    params: {
                        mapParams: new mx.comp.MapParams(
                            this.aocStore && this.aocStore.data.get(0).get('area_data')
                                ? mx.comp.mapComponent.getMapParamsFromAOC(this.aocStore.data.get(0))
                                : mx.comp.mapComponent.getMapParamsFromRegDivision(this.divisionStore.data.get(0))
                        ),
                    },
                },
            });
            if (this.mapWindow.formClassConfig.params.mapParams.valid()) {
                this.mapWindow.show();
            }
        } else {
            this.circle = null;
            this.setValue('');
            this.trigger.dom.className = 'x-form-trigger mx-comp-draw-circle-trigger';
            this.trigger.dom.title = this.labels.mapWindowTitle;
        }
    },
});
